module.exports = __webpack_public_path__ + "static/part-7-2184b1c35920cfc7a09e10660dea04eb.svg";